import { Component, Input, Output, EventEmitter } from '@angular/core';
import { EventLoggerService } from '@services/event-logger-service';
import { RegimenExpiryService } from '@services/regimen-expiry-service/regimen-expiry.service';
import { Router } from '@angular/router';

@Component({
  selector: 'regimen-expired-banner',
  imports: [],
  templateUrl: './regimen-expired-banner.component.html',
})
export class RegimenExpiredBannerComponent {
  @Input() regimenExpiredBannerData: { firstName: string, image: string };
  @Output() hideBanner = new EventEmitter<void>();

  constructor(
    private readonly eventLoggerService: EventLoggerService,
    private readonly regimenExpiryService: RegimenExpiryService,
    private readonly router: Router,
  ) {}

  closeBottomSheet(event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    this.eventLoggerService.cleverTapEvent('click', JSON.stringify({ name: 'hide_regimen_expired_banner' }));
    this.regimenExpiryService.disableRegimenExpiredBanner();
    this.hideBanner.emit();
  }

  onBannerClick(): void {
    this.eventLoggerService.cleverTapEvent('click', JSON.stringify({ name: 'regimen_expired_banner' }));
    this.router.navigate(['/re-acquisition/concern-selection'], { queryParams: { isRebranding: true, isSpentLessThanThreshold: true } });
  }
}
